// extracted by mini-css-extract-plugin
module.exports = {"h2":"H2-module__h2___n7HMh"};